// Modules
import React, { Component, Fragment } from "react";

// Styles
import "./Day.scss"

// Interfaces
import {Tip} from "Interfaces/TipInterface";
import moment from "moment";

interface IProps {
    day:Date;
    activeDate: Date | null;
    dayEnabled: boolean;
    pointsData: any
    rangeStartDate?: string;
    rangeEndDate?: string;
}

interface IState {

}

class Day extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
    }

    isDateToday(date:Date):boolean {
        let today = new Date();
        return this.datesEqual(date, today);
    }

    datesEqual(date1:Date, date2:Date):boolean {
        if(date1.getDate() === date2.getDate() &&
           date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() ) {
               return true;
           } else {
               return false;
           }
    }

    stripTime(date:Date):Date {
        return new Date(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`);
    }

    getClassList(selected: boolean):string[] {
        let classList = ["day"];

        if(selected) {
            classList.push("day-selected");
          } 

        // if(this.props.dayEnabled) {
        //   classList.push("enabled");
        // } else {
        //   classList.push("disabled")
        // }
        return classList;
    }

    checkisSelected = () => {

        if (this.props.rangeStartDate && this.props.rangeEndDate) {
            const result = moment(this.props.day).isBetween(this.props.rangeStartDate, this.props.rangeEndDate)
            if (result) {
                return true
            }
            if (moment(this.props.day).diff(moment(this.props.rangeStartDate), 'days') === 0) {
                return true
            }
            if (moment(this.props.day).diff(moment(this.props.rangeEndDate), 'days') === 0) {
                return true
            }
        }
        return false
    }

    render() {
        const selected = this.checkisSelected();
        return (
          <div className="day-container">
  
                <button
                  aria-label={this.props.day.toDateString()}
                  className={this.getClassList(selected).join(" ")}
                >
                    <div className="date">
                        <div className={selected ? "date-heading date-heading-selected" : "date-heading"}><p>{this.props.day.getDate()}</p></div>
                        <div className="point-heading"><p>{this.props.pointsData}</p></div>
                        
                    </div>
                </button>
          </div>
        );
    }
}

export default Day;
